import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import ExclamationIcon from './exclamation.svg';

import style from './AccountsExclamation.scss';

const cn = bemCssModules(style, 'AccountsExclamation');

const AccountsExclamation: CustomFC = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={cn(null, [className])}>
      <ExclamationIcon className={cn('icon')} />
      <p>{t('iban.exclamation')}</p>
    </div>
  );
};

export default AccountsExclamation;
